/**
 * Поиск адреса. Идёт через прокси на бэкенде (`pos.views.geocode`), а не напрямую
 * в Яндекс: ключ геокодера остаётся на сервере.
 */

import { apiFetch } from "./api";

/**
 * @param {string} query свободный адрес
 * @returns {Promise<{lat:number, lng:number, address:string}|null>} null — не найдено
 * @throws при сетевой ошибке или ошибке сервиса
 */
export async function geocodeAddress(query) {
  const data = await apiFetch(`/api/product/geocode/?q=${encodeURIComponent(query)}`);
  const results = (data && data.results) || [];
  if (results.length === 0) return null;

  const first = results[0];
  return { lat: first.latitude, lng: first.longitude, address: first.address };
}
